module.exports = __webpack_public_path__ + "assets/images/ll-upsell-bg@3x-8961f0d9ac12752c6e0d1e05d77b5690.png";